//对象工具方法
let objUtil = {
    //防抖节流方法
    timerUtil:{
        timer:null,//延时器(同时调用请使用./util中深拷贝方法Util.deepCopyObjectWithMethods,不同方法同时使用一个timer会出现问题)
        func:"",//延时后需要触发的方法
        params:"",//延时后需要触发的方法的参数
        time:"",//防抖节流时间
        //清除延时器方法
        clearTimer:function(){
            clearTimeout(this.timer)
            this.timer = null
        },
        //设置延时器方法
        setTimer:function({isRunFunc=1}){//isRunFunc是否执行方法，区别节流还是防抖
            this.clearTimer()
            this.timer = setTimeout(()=>{
                this.clearTimer(this.timer)
                if(isRunFunc){
                    this.runFunc()
                }
            },this.time)
        },
        //执行方法
        runFunc:function(){
            if(this.func!==""){
                this.func(this.params)
            }
        },
        //对传入方法进行防抖
        setFunc:function({func="",params="",time=500,isRun=0}){
            //func 防抖执行方法
            //params 防抖执行方法的参数
            //time 防抖时间
            //isRun 是否在防抖保护时间以外触发该方法时，立刻执行传入方法后，再对传入方法进行防抖，0：只延迟执行，1：执行后防抖
            this.func = func
            this.params = params
            this.time = time
            let isRunFunc = 1
            if(isRun===1&&this.timer===null){
                this.runFunc()
                isRunFunc = 0
            }
            this.setTimer({isRunFunc})
        },
        //对传入方法进行节流
        setTimeFunc:function({func="",params="",time=500}){
            this.func = func
            this.params = params
            this.time = time
            if(this.timer===null){
                this.runFunc()
                this.setTimer({isRunFunc:0})
            }
        }
    }
}
export default objUtil